module.exports = __webpack_public_path__ + "6be22080632705a53b6a94c3b3d56c3b.pdf";